<template>
  <page-outline :title="pageTitle">
    <template slot="pageContent">
      <b-row class="pb-3 no-gutter">
        <back-button :returnUrl="returnUrl"/>
      </b-row>
      <spinner v-if="activateSpinner" />
      <form-accordion
        v-else
        :title="$t('common.global.infos_provider')"
        :isTitleUpperCase="false">
        <b-row class="form-group">
          <b-col
            v-if="isEditable"
            cols="6">
            <form-write-group-label-input
              v-model="identifier"
              isMandatory
              :inputLabel="$t('common.global.bic')" />
          </b-col>
          <b-col
            v-else
            cols="6"
            class="form-group">
            <form-write-group-label-input
              v-model="identifier"
              disabled
              :inputLabel="$t('common.global.bic')" />
          </b-col>
        </b-row>
        <b-button-group v-if="networkList.length || addableNetwork.length">
          <b-button
            v-for="(network, idxTab) in networkList"
            :key="network.idRTPNetwork"
            :variant="tabNetwork === idxTab ? 'primary' : ''"
            @click="tabNetwork = idxTab">
            {{ network.name }}
          </b-button>
          <b-dropdown
            v-if="isEditable && addableNetwork.length"
            class="no-caret"
            text="Add Network">
            <b-dropdown-item
              v-for="network in addableNetwork"
              :key="network.id"
              @click="addNetwork(network)">
              {{ network.name }}
            </b-dropdown-item>
          </b-dropdown>
        </b-button-group>
        <b-tabs
          v-if="networkList.length"
          :key="'network-list-index-' + tabNetwork"
          v-model="tabNetwork"
          class="mt-3"
          nav-class="d-none">
          <b-tab
            v-for="(network, networkIndex) in networkList"
            :key="network.idRTPNetwork">
            <b-row>
              <b-col
                cols="6"
                class="form-group">
                <form-write-group-label-input
                  v-model="network.memberName"
                  isMandatory
                  :mandatoryErrorIndicator="hasError && !network.memberName"
                  :disabled="!isEditable || network.idNorm === 3"
                  :inputLabel="$t('common.global.provider_title')" />
              </b-col>
              <b-col class="form-group" v-if="network.dateLastUpdate">
                <form-read-group-label-input
                  :inputLabel="$t('common.global.date_last_update')"
                  :inputValue="$options.filters.formatDateTime(network.dateLastUpdate)">
                </form-read-group-label-input>
              </b-col>
            </b-row>
            <b-row
              v-if="network.tokenIO && network.tokenIO.length"
              class="mb-2 w-50">
              <b-col>
                <span>{{ $t('common.global.tokenio') }}</span>
              </b-col>
            </b-row>
            <b-row
              v-if="network.tokenIO && network.tokenIO.length"
              class="mb-2 w-50">
              <b-col>
                <div class="d-flex align-items-center justify-content-between px-3 py-2 radio-list">
                  <b-col class="fw-bold">
                    {{ $t('common.global.tokenio_name') }}
                  </b-col>
                  <b-col class="fw-bold">
                    {{ $t('common.global.tokenio_idBank') }}
                  </b-col>
                  <div
                    v-if="network.tokenIO && network.tokenIO.length > 1"
                    class="fw-bold col-1 d-flex justify-content-end">
                    {{ $t('common.default') }}
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row
              v-for="(tokenio, tokenIndex) in network.tokenIO"
              :key="tokenio.id"
              class="mb-2 w-50">
              <b-col>
                <div
                  class="d-flex align-items-center justify-content-between px-3 py-2 bg-light radio-list"
                  :class="selectedDefaultIdError ? 'errorBorder': 'border'">
                  <b-col class="fw-bold">
                    <span v-if="true">{{ tokenio.name }}</span>
                    <form-write-group-label-input
                      v-else
                      v-model="tokenio.name"
                      isMandatory
                      :mandatoryErrorIndicator="hasError && !tokenio.name" />
                  </b-col>
                  <b-col >
                    <span v-if="true">{{ tokenio.idBank }}</span>
                    <form-write-group-label-input
                      v-else
                      v-model="tokenio.idBank"
                      isMandatory
                      :mandatoryErrorIndicator="hasError && !tokenio.idBank" />
                  </b-col>
                  <b-form-radio
                      v-if="network.tokenIO && network.tokenIO.length > 1"
                      v-model="selectedDefaultId"
                      :value="tokenio.idTokenIO"
                      name="default-token"
                      class="col-1 d-flex justify-content-end"
                      :class="selectedDefaultIdError ? 'radio-border-error' : ''"
                      :disabled="!isEditable"
                      @click="selectDefaultIdTokenIO(tokenio.idTokenIO)">

                        <span class="sr-only">
                          {{ $t('common.default_token') }} {{ tokenio.idTokenIO }}
                        </span>
                  </b-form-radio>
                  <i
                    v-if="false && isEditable && network.tokenIO && network.tokenIO.length && tokenIndex === 0"
                    class="fa fa-plus text-success"
                    @click="addTokenIO(networkIndex)" />
                  <i
                    v-if="false && isEditable && network.tokenIO && network.tokenIO.length && tokenIndex !== 0"
                    class="fa fa-trash text-danger"
                    @click="deleteTokenIO(networkIndex, tokenIndex)" />
                </div>
              </b-col>
            </b-row>
            <div
              v-if="selectedDefaultIdError"
              page=""
              class="text-danger form-group">
              {{ $t('errors.is_mandatory', { mandatoryValue: $t('common.global.tokenio').toLowerCase() }) }}
            </div>
          </b-tab>
        </b-tabs>
      </form-accordion>
      <b-col class="mt-3">
        <span
          v-if="isEditable"
          class="color-red">* {{ $t('common.required_fields') }}
        </span>
      </b-col>
      <b-row class="justify-content-end no-gutter">
        <b-button
          v-if="isEditable && formType !== 'add'"
          variant="primary"
          class="mx-3"
          @click="switchMode('view')">
          <span>{{ $t('common.cncl') }}</span>
        </b-button>
        <b-button
          v-if="canEdit && !isEditable && formType !== 'add'"
          variant="primary"
          class="mx-3"
          @click="switchMode('edit')">
          <span>{{ $t('administration.edit') }}</span>
        </b-button>
        <b-button
          v-if="canDelete && isEditable"
          variant="primary"
          class="mx-3"
          @click="deleteNetwork">
          <i class="fa-light fa-trash" />
          <span>{{ $t('rights.delete') }}</span>
        </b-button>
        <b-button
          v-if="canDeleteProvider && !isEditable && formType !== 'add'"
          variant="primary"
          class="mx-3"
          @click="deleteProvider">
          <i class="fa-light fa-trash" />
          <span>{{ $t('rights.delete') }}</span>
        </b-button>
        <b-button
          v-if="isEditable && formType !== 'add'"
          variant="primary"
          class="mx-3"
          @click="editProvider">
          <i class="fa-light fa-save" />
          <span>{{ $t('common.sve') }}</span>
        </b-button>
        <b-button
          v-if="formType === 'add'"
          variant="primary"
          class="mx-3"
          @click="addProvider">
          <i class="fa-light fa-save" />
          <span>{{ $t('common.sve') }}</span>
        </b-button>
      </b-row>
    </template>
  </page-outline>
</template>

<script>

// import _ from 'lodash'

import backButton from "@/components/common/backButton.vue"
// import ConfigEntreeForm from '@/pages/routing/global/ConfigEntreeForm.vue'
// import ConfigSortieForm from '@/pages/routing/global/ConfigSortieForm.vue'
import FormAccordion from '@/components/common/FormAccordion.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import Spinner from '@/components/common/spinner.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import _ from 'lodash'

export default {
  name: 'ProviderForm',
  components: {
      'back-button': backButton,
      // 'config-entree-form': ConfigEntreeForm,
      // 'config-sortie-form': ConfigSortieForm,
      'form-accordion': FormAccordion,
      'form-read-group-label-input': formReadGroupLabelInput,
      'form-write-group-label-input': formWriteGroupLabelInput,
      'page-outline': PageOutline,
      'spinner': Spinner
    },
  props: {
      mode: {
        type: String,
        default: 'add'
      },
      id: {
        type: String,
        default: '-1'
      }
  },
  data: () => {
    return {
      activateSpinner: false,
      configIn: {},
      currentProvider: {},
      formType: 'add',
      hasError: false,
      identifier: '',
      networkItems: [],
      networkList: [],
      networkSelected: {},
      networkValue: {},
      networkValueError: false,
      name: '',
      originIdentifier: '',
      originName : '',
      originNetworks: [],
      originDefaultId: '',
      providerType: 'PROVIDER',
      providerTypeError: false,
      providerTypeList: [],
      returnUrl: '/routing/provider',
      selectedDefaultId: '',
      selectedDefaultIdError: false,
      tabNetwork: 0,
      tokenioList: []
    }
  },
  computed: {
    addableNetwork () {
      return this.networkItems.filter(elem => !this.networkList.map(elem2 => elem2.name).includes(elem.name) && elem.norm !== 'PSD2')
    },
    canDelete () {
      return !this.activateSpinner && this.$engine.rights.rightIs('rtp_member_supprimer', true) && this.networkList.length && this.networkList[this.tabNetwork].idNorm !== 3
    },
    canDeleteProvider () {
      return !this.activateSpinner && this.$engine.rights.rightIs('rtp_member_supprimer', true) && !this.networkList.filter(elem => elem.idNorm === 3).length
    },
    canEdit () {
      return !this.activateSpinner && this.$engine.rights.rightIs('rtp_member_editer', true) && !this.$engine.rights.getCurrentCountry().idCountry
    },
    canSeeSRTP () {
      return this.formType === 'add' || (this.formType === 'edit')
    },
    canSeeHRTP () {
      return this.formType === 'add' || (this.formType === 'edit')
    },
    canSeePSD2 () {
      return (this.formType === 'edit')
    },
    isEditable () {
      return (this.formType === 'add' || this.formType === 'edit')
    },
    pageTitle () {
      return this.$i18n.t('common.global.' + this.mode + '_provider')
    }
  },
  watch: {
    tabNetwork () {
      if (this.isEditable) {
        this.Dom7('input').addClass('display-error')
        this.Dom7('input').focus()
        this.Dom7('button').focus()
        this.Dom7('input').removeClass('display-error')
      }
    }
  },
  created () {
      this.activateSpinner = true
      this.formType = this.mode
      this.providerTypeList = [
        {
          id: 1,
          name: "CUSTOMER",
        },
        {
          id: 2,
          name: "PROVIDER",
        },
        {
          id: 3,
          name: "SI",
        },
      ]
      this.getNetworks()
      if (this.formType === 'view') {
        this.getProviders()
      } else {
        this.activateSpinner = false
      }
  },
  methods: {
    addNetwork (network) {
      let newNetwork = {
        idRTPNetwork: Number(network.id),
        name: network.name,
        norm: network.norm
      }
      if (network.norm === 'PSD2') {
        newNetwork.tokenIO = [{
          idTokenIO: 1,
          default: 1
        }]
        this.selectedDefaultId = 1
      }

      let index = this.networkList.findIndex(item => parseInt(item.idRTPNetwork) > parseInt(network.id))
      if (index === -1) {
        this.networkList.push(newNetwork)
        this.$nextTick(() => {
          this.tabNetwork = this.networkList.length - 1
        })
      } else {
        this.networkList.splice(index, 0, newNetwork)
        this.$nextTick(() => {
          this.tabNetwork = index
        })
      }
      // this.networkList = _.cloneDeep(this.networkList)
    },
    addProvider () {
      let that = this

      this.Dom7('input').addClass('display-error')
      this.Dom7('input').focus()
      this.Dom7('button').focus()
      this.Dom7('input').removeClass('display-error')

      if (this.formHasError()) {
        return
      }

      let params = {
        identifier: this.identifier,
        networks: this.networkList.map(elem => {
          let res = {
            idRTPNetwork: elem.idRTPNetwork,
            name: elem.memberName
          }
          if (elem.norm === 'PSD2') {
            res.tokenIO = elem.tokenIO.map(token => {
              return {
                default: token.default,
                idBank: token.idBank,
                name: token.name
              }
            })
          }
          return res
        })
      }

      this.$engine.routing.member.create(params)
      .then(() => {
          that.okMessageBox(that.$t('common.global.provider_added'))
          loadPage(that, {url: '/routing/provider'})
        })
        .catch(e => {
          errorMessageAlert(e, this)
          this.okMessageBox(this.$t('common.global.provider_addition_error'))
        })
    },
    addTokenIO (networkIndex) {
      let lastId = this.networkList[networkIndex].tokenIO[this.networkList[networkIndex].tokenIO.length - 1].idTokenIO
      this.networkList[networkIndex].tokenIO.push({idTokenIO: lastId + 1, default: 0})
    },
    deleteNetwork () {
      // does not delete provider anymore, only network, delete provider only if last network deleted
      if (this.networkList.length > 1 || this.formType === 'add') {
        this.networkList.splice(this.tabNetwork, 1)
        if (this.tabNetwork === this.networkList.length) {
          this.tabNetwork--
        }
      } else {
        let that = this
        let params = {
          idMember: this.id,
        }
        this.$engine.routing.member.delete(params)
        .then(() => {
            that.$f7.modal({
              title: that.$t('common.global.provider_deleted'),
              buttons: [
                {
                  text: 'OK',
                  onClick: function () {
                    return
                  }
                }
              ]
            })
            loadPage(that, {url: '/routing/provider'})
          })
          .catch(e => {
            errorMessageAlert(e, this)
            this.okMessageBox(this.$t('common.global.provider_deletion_error'))
          })
      }
    },
    deleteProvider () {
      let that = this
      let params = {
        id: this.id
      }
      this.$engine.routing.member.delete(params)
      .then(() => {
        that.$f7.modal({
          title: that.$t('common.global.provider_deleted'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/routing/provider'})
      })
      .catch(e => {
        errorMessageAlert(e, this)
        this.okMessageBox(this.$t('common.global.provider_deletion_error'))
      })
    },
    deleteTokenIO (networkIndex, tokenIndex) {
      this.networkList[networkIndex].tokenIO.splice(tokenIndex, 1)
      if (!this.networkList[networkIndex].tokenIO.filter(elem => elem.default === 1).length) {
        this.networkList[networkIndex].tokenIO[0].default = 1
      }
      if (!this.networkList[networkIndex].tokenIO.filter(elem => elem.idTokenIO === this.selectedDefaultId).length) {
        this.selectedDefaultId = 1
      }
    },
    editProvider () {
      let that = this

      this.Dom7('input').addClass('display-error')
      this.Dom7('input').focus()
      this.Dom7('button').focus()
      this.Dom7('input').removeClass('display-error')

      if (this.formHasError()) {
        return
      }

      let params = {
        idRTPBic: this.id
      }

      params.addNetworks = this.networkList.filter(
        network => !this.originNetworks.map(
          oNetwork => oNetwork.idRTPNetwork
        ).includes(network.idRTPNetwork)
      ).map(network => {
        return {
          idRTPNetwork: network.idRTPNetwork,
          name: network.memberName
        }
      })
      if (!params.addNetworks.length) {
        delete params.addNetworks
      }

      params.editNetworks = this.networkList.filter(
        network => {
          let origIndex = this.originNetworks.findIndex(elem => elem.idRTPNetwork === network.idRTPNetwork)
          return origIndex !== -1 && this.originNetworks[origIndex].memberName !== network.memberName
        }
      ).map(network => {
        return {
          idRTPNetwork: network.idRTPNetwork,
          name: network.memberName
        }
      })
      if (!params.editNetworks.length) {
        delete params.editNetworks
      }

      params.deleteNetworks = this.originNetworks.filter(
        oNetwork => !this.networkList.map(
          network => network.idRTPNetwork
        ).includes(oNetwork.idRTPNetwork)
      ).map(oNetwork => oNetwork.idRTPNetwork)
      if (!params.deleteNetworks.length) {
        delete params.deleteNetworks
      }

      params.defaultTokenIO = this.selectedDefaultId !== this.originDefaultId ? this.selectedDefaultId : ''
      if (!params.defaultTokenIO) {
        delete params.defaultTokenIO
      }

      if (!params.addNetworks && !params.editNetworks && !params.deleteNetworks && !params.defaultTokenIO) {
        that.$f7.modal({
          title: that.$t('common.global.provider_edited'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/routing/provider'})
        return
      }
      this.$engine.routing.member.edit(params)
      .then(() => {
        that.$f7.modal({
          title: that.$t('common.global.provider_edited'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/routing/provider'})
      })
      .catch(e => {
        errorMessageAlert(e, this)
        this.okMessageBox(this.$t('common.global.provider_edition_error'))
      })
    },
    fillFields(){
      this.name = this.originName = this.currentProvider.name
      this.identifier = this.originIdentifier = this.currentProvider.identifier
      this.providerType = this.currentProvider.type
      this.networkSelected = { id: this.currentProvider.idNetwork, name: this.currentProvider.network, norm: this.currentProvider.norm, idChannelIn: ""}
      this.tokenioList = this.currentProvider.networks.filter(elem => elem.idNorm === 3)
      if (this.tokenioList && this.tokenioList[0]) {
        this.tokenioList = this.tokenioList[0].tokenIO
      }
      this.networkList = this.currentProvider.networks
      if (this.tokenioList?.length) {
        this.selectedDefaultId = this.tokenioList.filter(elem => elem.default === '1').length ? this.tokenioList.filter(elem => elem.default === '1')[0].idTokenIO : ''
        this.originDefaultId = this.selectedDefaultId
      }
      this.activateSpinner = false
    },
    formHasError () {
      let hasError = false
      if (!this.identifier) {
        hasError = true
      }

      if (this.networkList.filter(network => !network.memberName).length) {
        hasError = true
        let networkErrorList = this.networkList.filter(network => !network.memberName)
        if (!networkErrorList.map(elem => elem.idRTPNetwork).includes(this.networkList[this.tabNetwork].idRTPNetwork)) {
          this.tabNetwork = this.networkList.findIndex(elem => elem.idRTPNetwork === networkErrorList[0].idRTPNetwork)
        }
      }

      if (this.networkList.filter(network => network.tokenIO && network.tokenIO.filter(token => !token.name || !token.idBank).length).length) {
        hasError = true
      }

      this.hasError = hasError
      return hasError
    },
    getProviders() {
      this.$engine.routing.member.fetch({idMember: this.id})
        .then(resp => {
          let that = this
          let providerList = {}
          providerList = resp.data.Member
          that.updateProvider(providerList)
        })
    },
    getNetworkDetails () {
      let that = this
      this.$engine.routing.network.fetch({id: this.networkSelected.id})
      .then(resp => {
        let selectedNetwork = {}

        selectedNetwork = resp.data.networks
        that.updateNetworkDetails(selectedNetwork)

        this.$f7.pullToRefreshDone()
      })
    },
    getNetworks () {
      let that = this

      this.$engine.routing.network.fetch()
      .then(resp => {
        let networkList = {}

        networkList = resp.data.networks
        that.updateNetworks(networkList)

        this.$f7.pullToRefreshDone()
        if (!this.$engine.rights.rightIs('super_admin', true)) {
          this.networkItems.forEach(element => {
            if (element.id == this.$engine.user.getUserNorm()){
              this.networkSelected = element
            }
          })
        }
        this.getNetworkDetails()
      })
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    selectDefaultIdTokenIO (id) {
      if (this.isEditable) {
        this.selectedDefaultId = id
      }
    },
    switchMode (mode) {
      if (mode === 'view') {
        this.networkValueError = false
        this.selectedDefaultIdError = false
        this.selectedDefaultId = this.originDefaultId
        this.currentProvider.networks = _.cloneDeep(this.originNetworks)
        this.networkList = this.originNetworks
      }
      this.formType = mode
    },
    updateProvider (providerList) {
      this.currentProvider = providerList
      this.originNetworks = _.cloneDeep(providerList.networks)
      this.fillFields()
    },
    updateNetworkDetails (selectedNetwork) {
      this.selectedNetwork = selectedNetwork[0]
    },
    updateNetworks (networkList) {
      this.networkItems = networkList
    }
  }
}
</script>
